/** Roles shown on homepage (Idea section) and apply form */
export const TRIBE_ROLE_CHIPS = [
  { label: "Designers", variant: "" },
  { label: "Writers", variant: "" },
  { label: "Strategists", variant: "accent" },
  { label: "Technologists", variant: "" },
  { label: "Filmmakers", variant: "" },
  { label: "AI explorers", variant: "lime" },
  { label: "Creative rebels", variant: "" },
];

/** Apply form dropdown — aligned with homepage chips */
export const APPLY_FORM_ROLES = [
  "Designer",
  "Writer",
  "Strategist",
  "Technologist",
  "Filmmaker",
  "AI explorer",
  "Creative rebel",
  "Graphic Designer",
  "Art Director",
  "UI/UX Designer",
  "Web Developer",
  "Application Developer",
  "Software Developer",
  "Content Writer",
  "Social Media Marketing",
  "Branding Consultant",
  "Other",
];
